import { render, staticRenderFns } from "./myQuestion.vue?vue&type=template&id=16c6b204&scoped=true&"
import script from "./myQuestion.vue?vue&type=script&lang=js&"
export * from "./myQuestion.vue?vue&type=script&lang=js&"
import style0 from "./myQuestion.vue?vue&type=style&index=0&id=16c6b204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c6b204",
  null
  
)

export default component.exports